export default __webpack_public_path__ + "static/GolosText-Medium-bc3d268f78b2682fb11c104b56104b67.ttf";